import PropTypes from "prop-types";
import React from "react";
import "./ClickableLabel.css"; // #region HOOK

/**
 * Représente un label sur lequel on peut cliquer
 * @class
 * @category Fields
 * @param {Fields.ClickableLabel.propTypes} props Les propriétés du champ
 */

function ClickableLabel(props) {
  // Récupération des props
  var onClick = props.onClick,
      text = props.text,
      textColor = props.textColor;
  return /*#__PURE__*/React.createElement("span", {
    className: "ClickableLabel",
    style: {
      color: textColor
    },
    onClick: onClick
  }, text);
} // #endregion}
// #region PROPRIETES

/**
 * Type des propriétés de {@link ClickableLabel}
 * @typedef {Object} ClickableLabel.propTypes
 * @property {string} text Le texte du label
 * @property {string} [textColor=#000] La couleur du texte
 * @property {function} [onClick=null] La fonction de callback de l'évènement onClick
 */


ClickableLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  onClick: PropTypes.func
} : {};
/*
  Valeurs par défaut des propriétés
*/

ClickableLabel.defaultProps = {
  textColor: "#000",
  onClick: null
}; // #endregion

export { ClickableLabel };